/**
 * @generated SignedSource<<0889acf3cb63d2904c65e3525ce94b75>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type TransactionType = "NEGOTIABLE" | "NON_NEGOTIABLE" | "OFF_PLATFORM" | "PRE_AUTH_NEGOTIATION" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type checkoutShippingReducer_preCheckoutTransaction$data = {
  readonly hasPartialShippingAddress: boolean | null;
  readonly isAuctionOrderType: boolean | null;
  readonly mostRecentOffer: {
    readonly priceBookName: string | null;
  } | null;
  readonly shipment: {
    readonly shippingAddress: {
      readonly city: string | null;
      readonly country: string | null;
      readonly priceBookName: string | null;
      readonly sourceId: string | null;
      readonly state: string | null;
      readonly zipCode: string | null;
    } | null;
  } | null;
  readonly transactionType: TransactionType | null;
  readonly " $fragmentType": "checkoutShippingReducer_preCheckoutTransaction";
};
export type checkoutShippingReducer_preCheckoutTransaction$key = {
  readonly " $data"?: checkoutShippingReducer_preCheckoutTransaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutShippingReducer_preCheckoutTransaction">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutShippingReducer_preCheckoutTransaction"
};

(node as any).hash = "21283e043fabbe434504f28e587dbbc3";

export default node;
